import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=c91f60f4&"
import script from "./errorPage.vue?vue&type=script&lang=js&"
export * from "./errorPage.vue?vue&type=script&lang=js&"
import style0 from "./errorPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports